import { useMemo } from 'react'

import { useRequiredActiveOrg } from '~/hooks/org'
import { getUserTreasuryPasskeyId } from '~/hooks/useSmartAccountSetupStep'
import { OrgMemberRole } from '~/types'

export const useReviewStepData = () => {
  const org = useRequiredActiveOrg()

  const owners = org.members.filter((m) => m.role === OrgMemberRole.Owner)
  const invitations = org.invitations || []

  const ownersMissingDetails = useMemo(() => {
    return owners.filter(
      (m) =>
        !getUserTreasuryPasskeyId(m.id, org) ||
        !m.displayName ||
        !org.passkeys.find((p) => p.user?.id === m.id),
    )
  }, [org, owners])

  return {
    owners,
    ownersMissingDetails,
    invitations,
  }
}
